import { render, staticRenderFns } from "./DetailsCompetence.vue?vue&type=template&id=7024a84e&"
import script from "./DetailsCompetence.vue?vue&type=script&lang=ts&"
export * from "./DetailsCompetence.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsCompetence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports